import Paths from '../../types/Paths';
import generatePath from '../../util/generatePath';
import { addParametersToPath } from '../../util/queryString';

export const buildOrderCancellationPath = ({
  orderId = null,
  code = null,
} = {}) => {
  const path = orderId
    ? generatePath(Paths.OrderCancellationPopulateOrder, {
        orderId: orderId || undefined,
      })
    : generatePath(Paths.OrderCancellation);

  return addParametersToPath(path, code ? { code } : {});
};

export const isOrderCancellationEligible = ({ accountStore }) => {
  return !!(
    (!accountStore || accountStore.isOrderCancellationEnabled) &&
    !(accountStore && accountStore.loggedIn && accountStore.isRetailer)
  );
};

export const createOrderCancellationPayload = ({
  values,
  activeLocale,
  cancelWholeOrder,
  productDescription = null,
}) => {
  const normalizedOrderIdentifier = Number(
    String(values.orderIdentifier).trim()
  );

  return {
    email: values.email.trim(),
    orderIdentifier: normalizedOrderIdentifier,
    cancelWholeOrder,
    productDescription: cancelWholeOrder
      ? ''
      : ((productDescription ?? values.productDescription) || '').trim(),
    additionalMessage: (values.additionalMessage || '').trim(),
    lang: activeLocale,
    ...(values.recaptcha ? { recaptcha: values.recaptcha } : {}),
  };
};
